import React from 'react'

type Props = {
    title?: string
    className?: string
}

const SparkleIcon: React.FC<Props> = ({ title, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        className={className}>
        {title && <title>{title}</title>}
        <path
            d="M12.7513 8.74871L10.75 4.75L8.74871 8.74871L4.75 10.75L8.74871 12.7513L10.75 16.75L12.7513 12.7513L16.75 10.75L12.7513 8.74871Z"
            fill="#676767"
        />
    </svg>
)

export default SparkleIcon
